import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name"];

  continue(event) {
    if (!this.element.hasAttribute("data-naming")) return;

    event.preventDefault();
    if (this.nameTarget.reportValidity()) {
      this.element.removeAttribute("data-naming");
    }
  }
}
